import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { delay, finalize } from 'rxjs';
import { BusyService } from '../../services/busy.service';
import { SKIP_GLOBAL_LOADER } from '../http-context';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_LOADER)) {
    return next(req);
  }
  const busyService = inject(BusyService);
  busyService.busy();
  return next(req).pipe(
    delay(0),
    finalize(() => busyService.idle()));
};